import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { RateDtoEnfoque } from 'src/app/domain/models/dto/rate.dto';
import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  HubConnection,
  HubConnectionBuilder,
  IHttpConnectionOptions,
} from '@aspnet/signalr';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class BrokerHubService {
  private readonly applicationIdHeader = {
    'x-application-id': environment.APPLICATION_ID,
  };

  private hubConnection: HubConnection;
  private subject: Subject<RateDtoEnfoque> = new Subject();

  constructor(private readonly http: HttpClient) {
    this.createConnection();
    this.registerOnServerEvents();
  }

  private createConnection() {
    const hubOptions: IHttpConnectionOptions & {
      headers?: Record<string, string>;
    } = {
      headers: this.applicationIdHeader,
    };
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`${environment.WEB_SOCKET_URL}/brokerhub`, hubOptions)
      .build();
  }

  public startConnection(symbol: string) {
    this.hubConnection
      .start()
      .then(() => {
        this.connectStock(symbol);
      })
      .catch(() => {
        setTimeout(() => {
          this.startConnection(symbol);
        }, 5000);
      });
  }

  public getRateQuotation(
    currencyId: number,
    finalityId?: number,
    countryId?: number,
    amount?: number,
    eOrderRemmitanceType?: number,
    spread?: number,
    tariff?: number
  ) {
    let params = new HttpParams()
      .set('currencyId', currencyId.toString())
      .set('eOrderRemmitanceType', eOrderRemmitanceType.toString());

    if (finalityId) params = params.set('finalityId', finalityId.toString());
    if (countryId) params = params.set('countryId', countryId.toString());
    if (amount) params = params.set('amount', amount.toString());
    // if (spread) params = params.set('spread', spread.toString());
    // if (tariff) params = params.set('tariff', tariff.toString());

    return this.http.get<ResponseObjectModel<any>>(
      `${environment.API_BASE_URL}/v1/partner/stocks/get-quotation`,
      { params }
    );
  }

  public getCachedRate(symbol: string, spreadBanking?: boolean) {
    let headers = new HttpHeaders(this.applicationIdHeader);
    if (spreadBanking) {
      headers = headers.set('X-Spread', 'true');
    }

    return this.http.get<ResponseObjectModel<RateDtoEnfoque>>(
      `${environment.WEB_SOCKET_URL}/v1/stocks?symbol=${symbol}`,
      { headers }
    );
  }

  public newCompeletedRate(orderId: string) {
    return this.http.get<ResponseObjectModel<any>>(
      `${environment.API_BASE_URL}/v1/partner/stocks?orderId=${orderId}&mock=false`
    );
  }

  public getCachedRates() {
    const headers = new HttpHeaders({
      ...this.applicationIdHeader,
      'X-Spread': 'true',
    });

    return this.http.get<ResponseObjectModel<RateDtoEnfoque[]>>(
      `${environment.WEB_SOCKET_URL}/v1/stocks`,
      { headers }
    );
  }

  private registerOnServerEvents() {
    this.hubConnection.on('UpdatePrice', (data) => {
      this.subject.next(data);
    });
  }

  private connectStock(symbol: string) {
    this.hubConnection.invoke('ConnectToStock', symbol);
  }

  public onUpdatePrice() {
    return this.subject.asObservable();
  }

  public disconnect() {
    this.hubConnection.stop();
  }
}
